import createRoute  from '@widesk-ui/tools/createRoute';
import PartnerModel from '@models/website/PartnerModel';

const route = createRoute.dashboardFromModel(
	PartnerModel,
	'PartnerDashboard', {
		pathPrefix: '/configuration',
	});
export default route;
